import { Chip, IconButton, TableCell, TableHead, TableRow } from '@material-ui/core'
import { Delete, Edit } from '@material-ui/icons'
import React from 'react'
import { StaffTimeOffResponseType } from 'types/api/temple'

interface StaffTimeOffTableProps {
    items: StaffTimeOffResponseType[]
    editHandler?: (id: string | number) => void
    deleteHandler?: (id: string | number) => void
    deletingIds?: (string | number)[]
}

const label = (value: string) => value.split('_').map(item => item.charAt(0).toUpperCase() + item.slice(1)).join(' ')

const getTimeLabel = (item: StaffTimeOffResponseType) => {
    if (item.sessionType === 'time_based') return `${item.startTime} - ${item.endTime}`
    return label(item.sessionType)
}

const StaffTimeOffTable: React.FC<StaffTimeOffTableProps> = ({
    items,
    editHandler,
    deleteHandler,
    deletingIds = [],
}) => (
    <React.Fragment>
        <TableHead>
            <TableRow>
                <TableCell>Staff/Priest</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Dates</TableCell>
                <TableCell>Session</TableCell>
                <TableCell>Recurrence</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Reason</TableCell>
                {(editHandler || deleteHandler) && <TableCell align='right'>Actions</TableCell>}
            </TableRow>
        </TableHead>
        {items.map(item => (
            <TableRow key={item.id}>
                <TableCell>{item.staffName}</TableCell>
                <TableCell>{label(item.leaveType)} / {label(item.mode)}</TableCell>
                <TableCell>{item.startDate} to {item.endDate}</TableCell>
                <TableCell>{getTimeLabel(item)}</TableCell>
                <TableCell>
                    {item.mode === 'recurrence' ? `${label(item.recurrence)} every ${item.recurrenceInterval}` : '-'}
                </TableCell>
                <TableCell>
                    <Chip
                        size='small'
                        color={item.isActive ? 'primary' : 'default'}
                        label={item.isActive ? 'Active' : 'Inactive'}
                    />
                </TableCell>
                <TableCell>{item.reason || '-'}</TableCell>
                {(editHandler || deleteHandler) && (
                    <TableCell align='right'>
                        {editHandler && (
                            <IconButton onClick={() => editHandler(item.id)}>
                                <Edit fontSize='small' />
                            </IconButton>
                        )}
                        {deleteHandler && (
                            <IconButton
                                disabled={deletingIds.includes(item.id)}
                                onClick={() => deleteHandler(item.id)}
                            >
                                <Delete fontSize='small' />
                            </IconButton>
                        )}
                    </TableCell>
                )}
            </TableRow>
        ))}
        {items.length === 0 && (
            <TableRow>
                <TableCell colSpan={8}>No leave or time off records found</TableCell>
            </TableRow>
        )}
    </React.Fragment>
)

export default StaffTimeOffTable
